import React, { useState, FormEvent } from 'react'
import { Toast } from 'antd-mobile'

import styles from './FilterModal.module.less'

import { t } from '@/utils/i18n'
import useCorpInfoStore from '@/stores/corp-info'

import type { FilterOption } from '@/types/product'

interface FilterModalProps {
  min: string
  max: string
  deliveryType: number[]
  onChangeFilter: (option: FilterOption) => void
  onToggleShowFilterModal: () => void
}

const FilterModal: React.FC<FilterModalProps> = (props) => {
  const { min, max, deliveryType, onChangeFilter, onToggleShowFilterModal } =
    props
  const [minPrice, setMinPrice] = useState(min)
  const [maxPrice, setMaxPrice] = useState(max)
  const [activeDeliveryType, setActiveDeliveryType] =
    useState<number[]>(deliveryType)
  const deliveryTypeMaps = [
    {
      label: t('国内发货'),
      key: 1,
    },
    {
      label: t('海外发货'),
      key: 0,
    },
  ]

  const { corpInfo } = useCorpInfoStore()
  const { paiFaFlag } = corpInfo
  const isAgent = Boolean(paiFaFlag & 16) // 是否为站点企业

  const resetPriceFilter = () => {
    setMinPrice('')
    setMaxPrice('')
    setActiveDeliveryType([])
    onChangeFilter({
      minPrice: '',
      maxPrice: '',
      deliveryType: [],
    })
  }

  const handlePriceFilterChange = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const form = e.target
    const formData = new FormData(form as HTMLFormElement)
    const formJson = Object.fromEntries(formData.entries())

    if (
      (formJson.minPrice && !validationFormat(String(formJson.minPrice))) ||
      (formJson.maxPrice && !validationFormat(String(formJson.maxPrice)))
    )
      return

    const newMinPrice = formJson.minPrice
      ? parseFloat(String(formJson.minPrice))
      : ''
    const newMaxPrice = formJson.maxPrice
      ? parseFloat(String(formJson.maxPrice))
      : ''

    if (newMaxPrice && newMinPrice && newMinPrice > newMaxPrice) {
      Toast.show({ content: t('最低价格需<=最高价格') })
      return
    }

    setMinPrice(String(newMinPrice))
    setMaxPrice(String(newMaxPrice))

    onChangeFilter({
      minPrice: String(newMinPrice),
      maxPrice: String(newMaxPrice),
      deliveryType: activeDeliveryType,
    })
  }

  const toggleShowFilterModal = () => {
    onToggleShowFilterModal()
  }

  function validationFormat(price: string) {
    const integerMaxLength = 8
    const pricePrecision = 2
    const [integer, decimal] = price.split('.')

    if (isNaN(parseFloat(price))) {
      Toast.show({
        content: t('请输入数字'),
      })
      return false
    }

    if (parseFloat(String(price)) < 0) {
      Toast.show({ content: t('价格不能小于0') })
      return false
    }

    if (integer.length > integerMaxLength) {
      Toast.show({
        content: t('整数位不能超过{{integerMaxLength}}位', {
          integerMaxLength: integerMaxLength,
        }),
      })
      return false
    }

    if (decimal && decimal.length > pricePrecision) {
      Toast.show({
        content: t('小数位不能超过{{pricePrecision}}位', {
          pricePrecision: pricePrecision,
        }),
      })
      return false
    }

    return true
  }

  function handleShippingTypeChange(key: number) {
    const index = activeDeliveryType.indexOf(key)
    if (index > -1) {
      activeDeliveryType.splice(index, 1)
    } else {
      activeDeliveryType.push(key)
    }

    setActiveDeliveryType(Array.from(activeDeliveryType))
  }

  const TabItem = () => {
    return deliveryTypeMaps.map((tab, index) => {
      return (
        <div
          className={styles['tab-item']}
          key={index}
          onClick={() => handleShippingTypeChange(tab.key)}
        >
          <div
            className={`${styles['tab-item-text']} ${
              activeDeliveryType.includes(tab.key) ? styles['active'] : ''
            }`}
          >
            {tab.label.replace(/(s|S)hipping/, '')}
          </div>
        </div>
      )
    })
  }

  return (
    <div className={styles['product-filter-modal']}>
      <form method="post" onSubmit={handlePriceFilterChange}>
        <div className={styles['product-filter-container']}>
          <div
            className={
              styles['product-filter-price'] +
              ' ' +
              styles['product-filter-item']
            }
          >
            <div className={styles['product-filter-title']}>{t('价格')}</div>
            <div className={styles['product-filter-item-content']}>
              {/* 最低价 */}
              <input
                className={styles['product-filter-price-min']}
                type="digit"
                name="minPrice"
                maxLength={11}
                placeholder={t('最低价格')}
                value={minPrice}
                onChange={(e) => setMinPrice(e.target.value)}
              />

              <span className={styles['product-filter-price-line']}>-</span>

              {/* 最高价 */}
              <input
                className={styles['product-filter-price-max']}
                type="digit"
                name="maxPrice"
                maxLength={11}
                placeholder={t('最高价格')}
                value={maxPrice}
                onChange={(e) => setMaxPrice(e.target.value)}
              />
            </div>
          </div>

          {/* 站点企业才显示发货类型 */}
          {isAgent && (
            <div className={styles['product-filter-item']}>
              <div className={styles['product-filter-title']}>
                {t('发货类型')}
              </div>
              <div className={styles['product-filter-item-content']}>
                <div className={styles['tab-warp']}>
                  <TabItem />
                </div>
              </div>
            </div>
          )}

          <div className={styles['product-filter-btn']}>
            <div
              className={styles['product-filter-cancel']}
              onClick={resetPriceFilter}
            >
              {t('重置')}
            </div>
            <button
              type="submit"
              className={
                styles['button-reset'] + ' ' + styles['product-filter-confirm']
              }
            >
              {t('确定')}
            </button>
          </div>
        </div>
      </form>
      <div className={styles['mark']} onClick={toggleShowFilterModal}></div>
    </div>
  )
}

export default FilterModal
